module.exports = __webpack_public_path__ + "static/media/boitesTupp_02_full.89340077.png";